import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn } from '../../components/Buttons';
import { StyledLabel } from '../../components/StyledComponents';
import { setIsOpenBoostersModal } from '../../redux/mainReducer';
import { makePaymentBooster } from '../../helpers/payments';
import BoosterPng from '../../assets/Booster.png';
import './CancelModal.css';
import ApiService from '../../helpers/apiHelper';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 700,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '24px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function BoostersModal({ isOpenModal }) {
  const apiBoosters = new ApiService('auth/user/get-booster-amount');
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);

  const [boostersAmount, setBoostersAmount] = useState(0);

  useEffect(() => {
    apiBoosters
      .getAll()
      .then((response) => {
        setBoostersAmount(response.result);
      })
      .catch((error) => console.log(error));
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenBoostersModal(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_cancel_modal"
      >
        <Box sx={style} className="bonfair_cancel_modal-box">
          <CloseIcon
            className="bonfair_cancel_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenBoostersModal(false));
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="cancelModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Придбати бустери'}
              </StyledLabel>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '2px solid #F0F0F0',
                pb: '30px'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  margin: '0px 20px 0px 0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#7c7c7c',
                  textAlign: 'left'
                }}
              >
                Баланс бустерів
              </Typography>
              <Typography
                variant="p"
                sx={{
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#1b1b1b',
                  textAlign: 'left'
                }}
              >
                {boostersAmount}
                <img
                  width={20}
                  height={16}
                  src={BoosterPng}
                  alt="booster"
                  style={{ marginLeft: '5px' }}
                />
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  margin: '0px 20px 0px 0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#7c7c7c',
                  textAlign: 'left'
                }}
              >
                Ціна за <span style={{ fontFamily: 'FixelText-Medium', color: '#1b1b1b' }}>1</span>
                <img
                  width={20}
                  height={16}
                  src={BoosterPng}
                  alt="booster"
                  style={{ marginLeft: '5px' }}
                />
              </Typography>
              <Typography
                variant="p"
                sx={{
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#1b1b1b',
                  textAlign: 'left'
                }}
              >
                20грн
                <span
                  style={{
                    fontFamily: 'FixelText-Medium',
                    fontSize: '16px',
                    color: '#7C7C7C',
                    marginLeft: '5px'
                  }}
                >
                  (з пдв)
                </span>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '2px solid #F0F0F0',
                pb: '20px'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  margin: '0px 20px 0px 0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#7c7c7c',
                  textAlign: 'left'
                }}
              >
                Кількість:
              </Typography>
              <Box sx={{ display: 'flex', height: 20 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '0px' }}>
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: value === 0 ? '#F5F4F4' : '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => value > 0 && setValue(value - 1)}
                  >
                    -
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: '500',
                      fontSize: { xs: '16px', sm: '18px', md: '20px' },
                      color: '#1B1B1B',
                      m: '0px 5px'
                    }}
                  >
                    {value}
                  </Typography>
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => value < 999 && setValue(value + 1)}
                  >
                    +
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  margin: '0px 20px 0px 0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  color: '#7c7c7c',
                  textAlign: 'left'
                }}
              >
                До сплати
              </Typography>
              <Typography
                variant="p"
                sx={{
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  textAlign: 'left'
                }}
              >
                {value * 20} грн
                <span
                  style={{
                    fontFamily: 'FixelText-Medium',
                    fontSize: '16px',
                    color: '#7C7C7C',
                    marginLeft: '5px'
                  }}
                >
                  (з пдв)
                </span>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '20px auto 0px',
                maxWidth: '540px'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                lineHeight="26px"
                disabled={value === 0}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  makePaymentBooster(dispatch, value);
                  dispatch(setIsOpenBoostersModal(false));
                }}
                width={180}
                margin={'0 auto'}
                style={{ textTransform: 'inherit' }}
                text="Оплатити"
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(BoostersModal);
